import { useIntl, type FormatNumberOptions } from 'react-intl';

import { useFormatPrice } from '@packages/shared/src/hooks/useFormatPrice/useFormatPrice';

type IntegerPrice = number;
type Percentage = number;

type AbsoluteDiscount = {
  priceDifference: IntegerPrice;
  currency: FormatNumberOptions['currency'];
};

type PercentDiscount = {
  discountPercentage: Percentage;
};

// TODO add tests
export const useFormatDiscount = () => {
  const { formatPrice } = useFormatPrice();
  const { formatNumber } = useIntl();

  const formatDiscount = (discount: AbsoluteDiscount | PercentDiscount) => {
    if ('priceDifference' in discount) {
      return formatPrice(discount.priceDifference, discount.currency);
    }
    if ('discountPercentage' in discount) {
      return formatNumber(discount.discountPercentage / 100, {
        style: 'percent',
      });
    }

    throw new Error('Invalid discount type');
  };

  return { formatDiscount };
};
